import React, { Component } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import CheckBox from '../widgets/checkbox.jsx';

class SurveyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usability: '',
      usabilityFeedback: '',
      features: '',
      gptFeedback: '',
      gptFeedbackOther: '',
      communicationBarriers: [],
      communicationBarriersOther: '',
      price: '',
      recommend: '',
      // Новые поля
      consultationsNumber: '',
      homeworkPlan: '',
      errors: {}
    };
  }

  handleUsabilityChange = (e) => {
    this.setState({ usability: e.target.value });
    this.clearError('usability');
  };

  handleUsabilityFeedbackChange = (e) => {
    this.setState({ usabilityFeedback: e.target.value });
    this.clearError('usabilityFeedback');
  };

  handleFeaturesChange = (e) => {
    this.setState({ features: e.target.value });
    this.clearError('features');
  };

  handleGptFeedbackChange = (e) => {
    this.setState({ gptFeedback: e.target.value });
    this.clearError('gptFeedback');
  };

  handleGptFeedbackOtherChange = (e) => {
    this.setState({ gptFeedbackOther: e.target.value });
    this.clearError('gptFeedbackOther');
  };

  // Скрытый вопрос — оставляем обработчик, но без обязательности
  handleCommunicationBarriersChange = (name, checked) => {
    this.setState((prevState) => ({
      communicationBarriers: checked
        ? [...prevState.communicationBarriers, name]
        : prevState.communicationBarriers.filter((option) => option !== name),
    }));
    this.clearError('communicationBarriers');
  };

  // Скрытый вопрос — оставляем обработчик, но без обязательности
  handleCommunicationBarriersOtherChange = (e) => {
    this.setState({ communicationBarriersOther: e.target.value });
    this.clearError('communicationBarriersOther');
  };

  // Скрытый вопрос — оставляем обработчик, но без обязательности
  handlePriceChange = (e) => {
    this.setState({ price: e.target.value });
    this.clearError('price');
  };

  handleRecommendChange = (e) => {
    this.setState({ recommend: e.target.value });
    this.clearError('recommend');
  };

  // Новые обработчики
  handleConsultationsNumberChange = (e) => {
    this.setState({ consultationsNumber: e.target.value });
    this.clearError('consultationsNumber');
  };

  handleHomeworkPlanChange = (e) => {
    this.setState({ homeworkPlan: e.target.value });
    this.clearError('homeworkPlan');
  };

  validateForm = () => {
    const errors = {};
    const {
      usability,
      usabilityFeedback,
      features,
      gptFeedback,
      gptFeedbackOther,
      recommend,
      consultationsNumber,
      homeworkPlan,
      // скрытые поля убрали из обязательных:
      // communicationBarriers,
      // communicationBarriersOther,
      // price,
    } = this.state;

    // Пример базовой валидации — можно доработать на своё усмотрение:
    if (!usability) errors.usability = true;
    if (
      (usability === 'inconvenient' || usability === 'veryInconvenient') &&
      !usabilityFeedback
    ) {
      errors.usabilityFeedback = true;
    }

    if (!features) errors.features = true;
    if (!gptFeedback) errors.gptFeedback = true;
    if (gptFeedback === 'other' && !gptFeedbackOther) errors.gptFeedbackOther = true;
    if (!recommend) errors.recommend = true;

    // Новые поля делаем обязательными:
    if (!consultationsNumber) errors.consultationsNumber = true;
    if (!homeworkPlan) errors.homeworkPlan = true;

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  clearError = (field) => {
    this.setState((prevState) => {
      const errors = { ...prevState.errors };
      delete errors[field];
      return { errors };
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      const {
        usability,
        usabilityFeedback,
        features,
        gptFeedback,
        gptFeedbackOther,
        communicationBarriers,
        communicationBarriersOther,
        price,
        recommend,
        consultationsNumber,
        homeworkPlan
      } = this.state;

      const surveyResults = {
        usability,
        usabilityFeedback,
        features,
        gptFeedback,
        gptFeedbackOther,
        communicationBarriers,       // скрытый вопрос всё равно сохраняется
        communicationBarriersOther,  // скрытый вопрос всё равно сохраняется
        price,                       // скрытый вопрос всё равно сохраняется
        recommend,
        consultationsNumber,         // новое поле
        homeworkPlan                 // новое поле
      };
      
      this.handleSaveResult(JSON.stringify(surveyResults, null, 2));
    }
  };

  handleSaveResult = async (result) => {
    console.log("handleSaveResult", result);

    this.props.eventToGAnalitycs('show_survey_save');
    const topic = this.props.tinode.getMeTopic();  
    const query = topic.startMetaQuery().withDesc().build();

    query.desc.inchatgpt = result ;
    query.desc.inchatgpttype = "savesurvey";
    
    try {
      const serverResult = await topic.getMeta(query);
      console.log('Success:', serverResult);
      this.props.onCancel();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  render() {
    const {
      usability,
      usabilityFeedback,
      features,
      gptFeedback,
      gptFeedbackOther,
      communicationBarriers,
      communicationBarriersOther,
      price,
      recommend,
      consultationsNumber,
      homeworkPlan,
      errors
    } = this.state;

    return (
      <div className="test-view-overlay">
        <div className="test-view-container">
          <form onSubmit={this.handleSubmit}>
            {/* Вопрос про удобство */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="usabilityQuestion"
                  defaultMessage="How do you rate the usability of our messenger?"
                />
              </label>
            </div>
            {errors.usability && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <div>
              <label className="test-option">
                <input
                  type="radio"
                  value="veryConvenient"
                  checked={usability === 'veryConvenient'}
                  onChange={this.handleUsabilityChange}
                />
                <FormattedMessage
                  id="veryConvenient"
                  defaultMessage="Very convenient"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="convenient"
                  checked={usability === 'convenient'}
                  onChange={this.handleUsabilityChange}
                />
                <FormattedMessage
                  id="convenient"
                  defaultMessage="Convenient"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="neutral"
                  checked={usability === 'neutral'}
                  onChange={this.handleUsabilityChange}
                />
                <FormattedMessage
                  id="neutral"
                  defaultMessage="Neutral"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="inconvenient"
                  checked={usability === 'inconvenient'}
                  onChange={this.handleUsabilityChange}
                />
                <FormattedMessage
                  id="inconvenient"
                  defaultMessage="Inconvenient"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="veryInconvenient"
                  checked={usability === 'veryInconvenient'}
                  onChange={this.handleUsabilityChange}
                />
                <FormattedMessage
                  id="veryInconvenient"
                  defaultMessage="Very inconvenient"
                />
              </label>
              {(usability === 'inconvenient' || usability === 'veryInconvenient') && (
                <div>
                  <label>
                    <FormattedMessage
                      id="usabilityFeedback"
                      defaultMessage="Why is it inconvenient?"
                    />
                  </label>
                  {errors.usabilityFeedback && (
                    <div className="error-message">
                      <FormattedMessage
                        id="requiredError"
                        defaultMessage="This question is required."
                      />
                    </div>
                  )}
                  <textarea
                    value={usabilityFeedback}
                    onChange={this.handleUsabilityFeedbackChange}
                  />
                </div>
              )}
            </div>

            {/* Вопрос про фичи */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="featuresQuestion"
                  defaultMessage="What features would you like to add or improve?"
                />
              </label>
            </div>
            {errors.features && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <textarea
              value={features}
              onChange={this.handleFeaturesChange}
            />

            {/* Вопрос про полезность ChatGPT */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="gptFeedbackQuestion"
                  defaultMessage="How do you rate the usefulness of ChatGPT's advice and messages?"
                />
              </label>
            </div>
            {errors.gptFeedback && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <div>
              <label className="test-option">
                <input
                  type="radio"
                  value="useless"
                  checked={gptFeedback === 'useless'}
                  onChange={this.handleGptFeedbackChange}
                />
                <FormattedMessage
                  id="useless"
                  defaultMessage="Useless or trivial"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="adequate"
                  checked={gptFeedback === 'adequate'}
                  onChange={this.handleGptFeedbackChange}
                />
                <FormattedMessage
                  id="adequate"
                  defaultMessage="Adequate and reasonable"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="veryUseful"
                  checked={gptFeedback === 'veryUseful'}
                  onChange={this.handleGptFeedbackChange}
                />
                <FormattedMessage
                  id="veryUseful"
                  defaultMessage="Very useful and profound"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="other"
                  checked={gptFeedback === 'other'}
                  onChange={this.handleGptFeedbackChange}
                />
                <FormattedMessage
                  id="other"
                  defaultMessage="Other"
                />
              </label>
              {gptFeedback === 'other' && (
                <div>
                  <label>
                    <FormattedMessage
                      id="gptFeedbackOther"
                      defaultMessage="Specify:"
                    />
                  </label>
                  {errors.gptFeedbackOther && (
                    <div className="error-message">
                      <FormattedMessage
                        id="requiredError"
                        defaultMessage="This question is required."
                      />
                    </div>
                  )}
                  <textarea
                    value={gptFeedbackOther}
                    onChange={this.handleGptFeedbackOtherChange}
                  />
                </div>
              )}
            </div>

            {/* Скрываем вопросы о барьерах общения и цене в один блок */}
            <div style={{ display: 'none' }}>
              {/* Вопрос про барьеры общения */}
              <div className="test-question">
                <label>
                  <FormattedMessage
                    id="communicationBarriersQuestion"
                    defaultMessage="What prevents you from communicating with a real person in our messenger to resolve issues?"
                  />
                </label>
              </div>
              <div>
                <div className="advice-check">
                  <CheckBox
                    name="fearOfOffending"
                    checked={communicationBarriers.includes('fearOfOffending')}
                    onChange={this.handleCommunicationBarriersChange}
                  />{' '}
                  &nbsp;
                  <FormattedMessage
                    id="fearOfOffending"
                    defaultMessage="I fear my partner will be offended"
                  />
                </div>
                <div className="advice-check">
                  <CheckBox
                    name="preferInPerson"
                    checked={communicationBarriers.includes('preferInPerson')}
                    onChange={this.handleCommunicationBarriersChange}
                  />{' '}
                  &nbsp;
                  <FormattedMessage
                    id="preferInPerson"
                    defaultMessage="I prefer to resolve issues in person"
                  />
                </div>
                <div className="advice-check">
                  <CheckBox
                    name="noBenefitFromChatGPT"
                    checked={communicationBarriers.includes('noBenefitFromChatGPT')}
                    onChange={this.handleCommunicationBarriersChange}
                  />{' '}
                  &nbsp;
                  <FormattedMessage
                    id="noBenefitFromChatGPT"
                    defaultMessage="I don't see any benefit from ChatGPT for such communication"
                  />
                </div>
                <div className="advice-check">
                  <CheckBox
                    name="other"
                    checked={communicationBarriers.includes('other')}
                    onChange={this.handleCommunicationBarriersChange}
                  />{' '}
                  &nbsp;
                  <FormattedMessage
                    id="other"
                    defaultMessage="Other"
                  />
                </div>
                {communicationBarriers.includes('other') && (
                  <div>
                    <label>
                      <FormattedMessage
                        id="communicationBarriersOther"
                        defaultMessage="Specify:"
                      />
                    </label>
                    <textarea
                      value={communicationBarriersOther}
                      onChange={this.handleCommunicationBarriersOtherChange}
                    />
                  </div>
                )}
              </div>

              {/* Вопрос про желаемую стоимость */}
              <div className="test-question">
                <label>
                  <FormattedMessage
                    id="priceQuestion"
                    defaultMessage="What price is acceptable for 2-3 dialogues?"
                  />
                </label>
              </div>
              <div>
                <label className="test-option">
                  <input
                    type="radio"
                    value="50rub"
                    checked={price === '50rub'}
                    onChange={this.handlePriceChange}
                  />
                  <FormattedMessage
                    id="50rub"
                    defaultMessage="50 rubles"
                  />
                </label>
                <label className="test-option">
                  <input
                    type="radio"
                    value="100rub"
                    checked={price === '100rub'}
                    onChange={this.handlePriceChange}
                  />
                  <FormattedMessage
                    id="100rub"
                    defaultMessage="100 rubles"
                  />
                </label>
                <label className="test-option">
                  <input
                    type="radio"
                    value="200rub"
                    checked={price === '200rub'}
                    onChange={this.handlePriceChange}
                  />
                  <FormattedMessage
                    id="200rub"
                    defaultMessage="200 rubles"
                  />
                </label>
              </div>
            </div>
            {/* Конец блока, который скрыт визуально */}

            {/* Вопрос "Посоветовали бы" */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="recommendQuestion"
                  defaultMessage="Would you recommend our messenger to friends?"
                />
              </label>
            </div>
            {errors.recommend && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <div>
              <label className="test-option">
                <input
                  type="radio"
                  value="yes"
                  checked={recommend === 'yes'}
                  onChange={this.handleRecommendChange}
                />
                <FormattedMessage
                  id="yes"
                  defaultMessage="Yes"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="no"
                  checked={recommend === 'no'}
                  onChange={this.handleRecommendChange}
                />
                <FormattedMessage
                  id="no"
                  defaultMessage="No"
                />
              </label>
            </div>

            {/* --- НОВЫЕ ВОПРОСЫ --- */}

            {/* 1) Вопрос про кол-во консультаций */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="consultationsNumberQuestion"
                  defaultMessage="Какое кол-во консультаций в рамках одной проблемы для вас было бы удобным?"
                />
              </label>
            </div>
            {errors.consultationsNumber && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <div>
              <label className="test-option">
                <input
                  type="radio"
                  value="10"
                  checked={consultationsNumber === '10'}
                  onChange={this.handleConsultationsNumberChange}
                />
                <FormattedMessage
                  id="consultationsNumberOption10"
                  defaultMessage="10 (как сейчас)"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="9-6"
                  checked={consultationsNumber === '9-6'}
                  onChange={this.handleConsultationsNumberChange}
                />
                <FormattedMessage
                  id="consultationsNumberOption9to6"
                  defaultMessage="9-6"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="5-3"
                  checked={consultationsNumber === '5-3'}
                  onChange={this.handleConsultationsNumberChange}
                />
                <FormattedMessage
                  id="consultationsNumberOption5to3"
                  defaultMessage="5-3"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="2-1"
                  checked={consultationsNumber === '2-1'}
                  onChange={this.handleConsultationsNumberChange}
                />
                <FormattedMessage
                  id="consultationsNumberOption2to1"
                  defaultMessage="2-1"
                />
              </label>
            </div>

            {/* 2) Вопрос про готовность делать домашнее задание */}
            <div className="test-question">
              <label>
                <FormattedMessage
                  id="homeworkPlanQuestion"
                  defaultMessage="Планируете ли вы делать домашнее задание, чтобы решение проблемы было более эффективным?"
                />
              </label>
            </div>
            {errors.homeworkPlan && (
              <div className="error-message">
                <FormattedMessage
                  id="requiredError"
                  defaultMessage="This question is required."
                />
              </div>
            )}
            <div>
              <label className="test-option">
                <input
                  type="radio"
                  value="yes"
                  checked={homeworkPlan === 'yes'}
                  onChange={this.handleHomeworkPlanChange}
                />
                <FormattedMessage
                  id="yesHomework"
                  defaultMessage="Да"
                />
              </label>
              <label className="test-option">
                <input
                  type="radio"
                  value="no"
                  checked={homeworkPlan === 'no'}
                  onChange={this.handleHomeworkPlanChange}
                />
                <FormattedMessage
                  id="noHomework"
                  defaultMessage="Нет"
                />
              </label>
            </div>
            {/* --- Конец новых вопросов --- */}

            <div className="dialog-buttons">
              <button className="primary" type="submit">
                <FormattedMessage id="submit" defaultMessage="Submit" />
              </button>

              <button className="secondary" type="button" onClick={this.props.onCancel}>
                <FormattedMessage
                  id="test_cancel"
                  defaultMessage="Cancel"
                  description="Cancel"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SurveyComponent;
